import { render, staticRenderFns } from "./OrganizationStepper.vue?vue&type=template&id=f8634da4&scoped=true"
import script from "./OrganizationStepper.vue?vue&type=script&lang=js"
export * from "./OrganizationStepper.vue?vue&type=script&lang=js"
import style0 from "./OrganizationStepper.vue?vue&type=style&index=0&id=f8634da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8634da4",
  null
  
)

export default component.exports